/**
 * The thumb controls' markup: the floating stick's three nested points and
 * the pad stack.  packages/client/src/touch.js is handed the root and queries only
 * inside it; whether any of this is visible at all is CSS off the html.touch
 * class touch.js sets on the first real touch.
 */
import "./touch.css";
import { mount } from "./dom.js";

export function mountTouch() {
  return mount(`
<!-- Thumb controls.  Empty of meaning until touch.js reveals them; the stick
     and the look drag are read off the canvas, so only the buttons are here
     as real elements. -->
<div id="touch">
  <div id="stick"><i id="stick-ring"></i><i id="stick-knob"></i></div>
  <div id="pads">
    <button data-touch="sit" type="button" aria-label="Sit"><span>sit</span></button>
    <button data-touch="claw" type="button" aria-label="Claws out, to cling to wood"><span>claws</span></button>
    <button data-touch="jump" type="button" aria-label="Jump. Hold to gather a pounce"><span>jump</span></button>
    <button data-touch="meow" type="button" aria-label="Meow"><span>meow</span></button>
    <button data-touch="say" type="button" aria-label="Say something"><span>say</span></button>
  </div>
</div>`);
}
